import '@fiverr/globals';

const serializeJson = (ary) => Object.keys(ary).map((key) => {
    if (Array.isArray(ary[key])) {
        const arrayParts = [];
        for (let i = 0; i < ary[key].length; i++) {
            arrayParts.push(`${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(ary[key][i])}`);
        }
        return arrayParts.join('&');
    }
    return `${encodeURIComponent(key)}=${encodeURIComponent(ary[key])}`;
}).join('&');


/**
 * Mutates the Gig data object
 * @param  {Object} gigData           Gig data object
 * @param  {Object} [options]
 * @param  {Object} [options.context] Context object
 * @return {Object} gigData           Mutated object
 */
const enrichGigsData = (gigs) => {
    if (gigs && gigs.length) {

        const gigIds = gigs.map((gig) => gig.gig_id);

        return gofor(`/cards/assets?${serializeJson({gig_ids: gigIds})}`, {
            method: 'GET',
            dataType: 'json',
            headers: {
                'Accept': 'text/javascript'
            }
        }).then((response) => response.ok && response.json()).then((data) => data);
    }
};

export default enrichGigsData;



// WEBPACK FOOTER //
// ./src/utils/enrichGigsData/index.js